'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import { useSession } from 'next-auth/react';
import { userTypeToAccountType } from '@/lib/homepageUtils';
import { cn } from '@/lib/utils';
import DesktopMenuPublic from './menu/DesktopMenuPublic';
import { getStaticMenuItems, getAuthMenuItems } from './menu/MenuPublicConfig';
import MobileMenuPublic from './menu/MobileMenuPublic';
import { SidebarTrigger } from '../ui/sidebar';

export default function HeaderPublic({ className }: { className?: string }) {
  const { data: session, status } = useSession();
  const searchParams = useSearchParams();
  const userType = searchParams.get('usertype');
  const menuItemsPublic = getStaticMenuItems();

  const menuItemsAuth =
    status === 'loading'
      ? []
      : getAuthMenuItems(
          session?.user?.id !== undefined,
          userTypeToAccountType(userType)
        );

  return (
    <>
      <header
        className={cn(
          'flex max-w-(--breakpoint-xl) items-center justify-between px-5 py-4 md:mx-auto md:w-full md:px-20 md:py-10',
          className
        )}
      >
        <Link href='/'>
          <Image
            src='/images/logo.svg'
            alt='Logo'
            width={102}
            height={19}
            className='hidden md:block'
          />
          <Image
            src='/images/logo.svg'
            alt='Logo'
            width={88}
            height={17}
            className='block md:hidden'
          />
        </Link>
        <DesktopMenuPublic
          menuItems={menuItemsPublic}
          menuItemsAuth={menuItemsAuth}
        />
        <SidebarTrigger className='p-0 text-black hover:bg-transparent md:hidden' />
      </header>
      <div className='md:hidden'>
        <MobileMenuPublic
          menuItems={menuItemsPublic}
          menuItemsAuth={menuItemsAuth}
        />
      </div>
    </>
  );
}
